import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatRadioChange } from '@angular/material';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IReference } from 'app/shared/models/recruitment/reference.model';
import { Observable, Subject } from 'rxjs';
import { IResult } from 'app/shared/models/result.model';
import { RecruitmentService } from 'app/views/appviews/recruitment/recruitment.service';
import { SnotifyService } from 'ng-snotify';
import { AppConfig } from 'app/app.config';
declare var $: any;
@Component({
  selector: 'app-modal-reference',
  styleUrls: ['./modal-reference.style.scss'],
  templateUrl: './modal-reference.template.html',
  encapsulation: ViewEncapsulation.None
})

export class ModalReferenceComponet implements OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private errorMessages: any;
  /**Formularios */
  private formReference: FormGroup;
  /**Variable de trasporte de datos */
  private result: IResult;
  private reference: IReference;
  private jobCandidateId: number;
  /**Notificaciones */
  private configToast: any;
  /**Retorno a pantalla padre */
  public onClose: Subject<IReference>;
  /**Variables */
  private buttonSubmit: string;
  constructor(private bsModalRef: BsModalRef
    , private formBuilder: FormBuilder
    , private recruitmentService: RecruitmentService
    , public snotifyService: SnotifyService
    , configGeneral: AppConfig) {
    this.initializeFormEmploymentHistory();
    this.configToast = configGeneral.getConfigToast();
  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }
  private initializeFormEmploymentHistory() {
    this.formReference = this.formBuilder.group({
      referenceType: [null, Validators.required],
      relationship: [null, [Validators.required, Validators.maxLength(100)]],
      fullName: [null, [Validators.required, Validators.maxLength(150)]],
      address: [null, [Validators.required, Validators.maxLength(150)]],
      phone: [null, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]]
    });
  }
  private radioChange($event: MatRadioChange) {
    switch ($event.source.name) {
      case 'referenceType':
        // this.relationshipType = $event.value;
        break;
    }
  }
  // save(): void {
  //   if (this.formReference.valid) {
  //     const data = this.mapReference(this.formReference.value);
  //     this.onClose.next(data);
  //     this.bsModalRef.hide();
  //     } else {
  //       this.snotifyService.error('Capture toda la información requerida para poder continuar'
  //       , 'Validación', this.configToast);
  //     }
  // }
  save($event): Observable<IResult> {
    if (this.formReference.valid) {
      const submit = document.getElementById(document.activeElement.id);
      this.buttonSubmit = submit.getAttribute('value');

      const data = this.mapReference(this.formReference.value);
      const addDoaObservable = this.recruitmentService.addRecluitment('reference', data);
      addDoaObservable
        .subscribe(
          (x) => {
            this.result = x;
            if (this.result.isCorrect === true) {
              this.reference = this.result.data as IReference;
              this.onClose.next(this.reference);
              switch (this.buttonSubmit) {
                case 'save':
                    this.bsModalRef.hide();
                  break;
                case 'save_more':
                    this.formReference.reset();
                  break;
              }
            } else {
              this.snotifyService.error('Error al procesar los datos'
                , 'Error', this.configToast);
            }
          },
          (errMessage) => this.errorMessages = errMessage.messages);
      return addDoaObservable;
    } else {
      this.snotifyService.error('Capture toda la información requerida para poder continuar'
        , 'Validación', this.configToast);
    }
  }
  private onCancel(): void {
    this.bsModalRef.hide();
  }
  private mapReference(form: any): IReference {
    const data = {} as IReference;
    data.referenceType = form.referenceType;
    data.relationship = form.relationship;
    data.fullName = form.fullName;
    data.address = form.address;
    data.phone = form.phone;
    data.jobCandidateId = this.jobCandidateId;
    data.isActive = true;
    data.isVisible = true;
    return data;
  }
}
